import {getCurrentYear} from '../../utils/commons'
import OzzieChoiceReviewsLogo from './logo'
import {ozzieChoiceReviewsStylesAU} from './styles'

const baseConfig = {
  domainName: 'ozziechoicereviews' as const,
  domainType: 'eu' as const,
  siteName: 'Ozzie Choice Reviews',
  favicon: '/favicons/ozziechoicereviews.png',
}

const localeConfigs = {
  au: {
    measurementId: 'G-9YRKSN1V2S',
    camelCaseUrl: 'OzzieChoiceReviews.au',
    logo: <OzzieChoiceReviewsLogo className="size-10 shrink-0 tablet:size-8" locale="au" />,
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in Australia | OzzieChoiceReviews.au - Unbiased Aussie Reviews & Guides`,
    description: (category?: string, _count?: string) =>
      `Discover Australia’s top ${category} for ${getCurrentYear()}. Expert reviews, honest ratings, and buying tips at OzzieChoiceReviews.au.`,
    styles: ozzieChoiceReviewsStylesAU,
  },
}

export const createConfig = (locale: string = 'au') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.au
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
